import api from './api';

export const getMyLeague      = () => api.get('/api/league/me');
export const getLeaderboard   = () => api.get('/api/league/leaderboard');
export const getLeagueHistory = () => api.get('/api/league/history');
